import { Outlet } from 'react-router';

import { useHideAndroidNavigationBar } from '@sorare/core/src/hooks/mobile/useHideAndroidNavigationBar';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const SeriesLayout = () => {
  useHideAndroidNavigationBar();

  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};

export default SeriesLayout;
